import type { Level, UserProgress } from "./types";
import { trainingPlan } from "./trainingPlan";

export function getCompletedCount(level: Level, progress: UserProgress): number {
  return level.exercises.filter((ex) => progress.completedExercises.includes(ex.id)).length;
}

export function isLevelUnlocked(levelIndex: number, progress: UserProgress): boolean {
  if (levelIndex === 0) return true;
  const prevLevel = trainingPlan[levelIndex - 1];
  return getCompletedCount(prevLevel, progress) >= prevLevel.requiredExercises;
}

export function isLevelCompleted(level: Level, progress: UserProgress): boolean {
  return getCompletedCount(level, progress) >= level.requiredExercises;
}

export function getTotalExerciseCount(): number {
  return trainingPlan.reduce((acc, l) => acc + l.exercises.length, 0);
}
